import React from "react";

// CSS
import "../../../css/edit-row-buttons/delete-btn.css";

class DeleteBtn extends React.PureComponent {
	render() {
		return (
			<button
				className="file-delete-btn"
				disabled={this.props.disabled}
				onClick={this.props.onClick}
				title="Delete"
			>
				<span className={this.props.loading ? "loading icon-spinner" : "icon-cross"} />
			</button>
		);
	}
}

export default DeleteBtn;



// WEBPACK FOOTER //
// ./src/components/utils/edit-item/DeleteBtn.js